import { useNavigate } from 'react-router-dom'
import { ButtonGroup, Button } from '@mui/material'

const Menu = ({ pass, template }) => {

  const navigate = useNavigate()

  const page = location.pathname.split("/").pop()

  if (pass) return (
    <div className='flex flex-row justify-end whitespace-nowrap'>
      <ButtonGroup variant="text" aria-label="Actions">
        <Button onClick={() => navigate("../details", { state: { pass }, replace: true })} sx={{color:page === "details" ? "link" : "text.secondary"}}>Details</Button>
        <Button onClick={() => navigate("../messages", { state: { pass }, replace: true })} sx={{color:page === "messages" ? "link" : "text.secondary"}}>Notifications</Button>
        <Button onClick={() => navigate("../edit", { state: { pass }, replace: true })} sx={{color:page === "edit" ? "link" : "text.secondary"}}>Edit</Button>
        {(template?.managed_pass_template === 1) && 
          <Button onClick={() => navigate("../scan-actions", { state: { pass }, replace: true })} sx={{color:page === "scan-actions" ? "link" : "text.secondary"}}>Scan Actions</Button>
        }
        {(template?.managed_pass_template === 1) && 
          <Button onClick={() => navigate("../scans", { state: { pass }, replace: true })} sx={{color:page === "scans" ? "link" : "text.secondary"}}>Scan History</Button>
        }
        <Button onClick={() => navigate("../install", { state: { pass }, replace: true })} sx={{color:page === "install" ? "link" : "text.secondary"}}>Install</Button>
      </ButtonGroup>
    </div>

  )
}

export default Menu